// extracted by mini-css-extract-plugin
module.exports = {"sortColumn":"sortableColumn_sortColumn__2EVEm","sortArrow":"sortableColumn_sortArrow__1aTpx"};